<p>confirm-modal works!</p>
<ion-item lines="full">
  <ion-title class="ion-no-padding ion-padding-vertical"
    ><b>{{ _title() | translate }}</b></ion-title
  >
  <ion-buttons slot="end">
    <ion-button (click)="dismissNo()"
      ><ion-icon name="close-outline"></ion-icon
    ></ion-button>
  </ion-buttons>
</ion-item>
<div class="ion-margin-bottom">
  <ion-grid class="ion-margin-top">
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-icon
          name="help-circle-outline"
          color="medium"
          class="icon-x3"
        ></ion-icon>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-label
          class="ion-no-padding ion-padding-horizontal panel-label-text"
        >
          {{ _message() | translate }}
        </ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
<ion-footer>
  <div class="ion-text-center ion-padding">
    <ion-button
      id="showmoddel"
      color="primary"
      (click)="dismissYes()"
      align-self-center
      ><small>{{ 'general_yes' | translate }}</small></ion-button
    >
    <ion-button
      id="showmoddel"
      color="primary"
      (click)="dismissNo()"
      align-self-center
      ><small>{{ 'general_no' | translate }}</small></ion-button
    >
  </div>
</ion-footer>
